import { ForwardedRef, forwardRef, PropsWithChildren } from 'react';

import styles from './FilterSection.module.css';

import { Typography } from '@bgzt/ui';

type Props = {
  title: string;
};

export const FilterSection = forwardRef(function FilterSection(
  { title, children }: PropsWithChildren<Props>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.titleContainer}>
        <Typography variant="L7" color="gray-200">
          {title}
        </Typography>
      </div>
      {children}
    </div>
  );
});
